<template>
  <div style="padding: 20px">
    <el-form
      label-width="130px"
      class="demo-ruleForm"
      :rules="rules"
      :model="formData"
      ref="ruleForm"
    >
      <el-form-item label="数量" prop="count">
        <el-input v-model.number="formData.count"></el-input>
      </el-form-item>
      <el-form-item label="半径（m）" prop="typicalRadius">
        <el-input v-model.number="formData.typicalRadius"></el-input>
      </el-form-item>
      <el-form-item label="坡度（°）" prop="inflowAngle">
        <el-input v-model.number="formData.inflowAngle"></el-input>
      </el-form-item>
      <el-form-item label="边界距离（m）" prop="distance">
        <el-input v-model.number="formData.distance"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="save">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      formData: {
        typicalRadius: '',
        count: '',
        inflowAngle: '',
        distance: ''
      },
      rules: {
        count: [
          { required: true, message: '请输入数量', trigger: 'blur' },
          { type: 'number', message: '只能输入数字', trigger: 'blur' }
        ],
        typicalRadius: [
          { required: true, message: '请输入半径', trigger: 'blur' },
          {
            min: 500,
            max: 30000,
            message: '半径大于等于500且小于等于30000',
            trigger: 'blur',
            type: 'number'
          }
        ],
        inflowAngle: [
          { required: true, message: '请输入坡度', trigger: 'blur' },
          {
            type: 'number',
            message: '坡度应在0°至90°之间',
            trigger: 'blur',
            min: 0,
            max: 90
          }
        ],
        distance: [
          {
            required: true,
            message: '请输入距边界距离,距离大于等于0',
            trigger: 'blur'
          },
          {
            message: '请输入距边界距离,距离大于等于0',
            trigger: 'blur',
            type: 'number'
          }
        ]
      }
    };
  },
  async mounted() {
    await this.getTowerDefaultCondition();
  },
  methods: {
    async getTowerDefaultCondition() {
      const { data } = await this.$fetch(
        '/manage/station/getTowerDefaultCondition',
        {
          module: 'manage'
        }
      );
      const {
        count,
        inflowAngle,
        typicalRadius,
        distance
      } = data.defaultParam[0];
      this.formData.typicalRadius = typicalRadius;
      this.formData.count = count;
      this.formData.inflowAngle = inflowAngle;
      this.formData.distance = +distance;
    },
    async save() {
      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          await this.$postForm({
            url: '/manage/station/saveTowerDefaultCondition',
            module: 'manage',
            data: {
              count: this.formData.count,
              inflowAngle: this.formData.inflowAngle,
              typicalRadius: this.formData.typicalRadius,
              distance: this.formData.distance
            },
            showLoading: true,
            showError: true,
            showSuccess: true
          });
          await this.getTowerDefaultCondition();
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .el-input__inner {
  width: 200px;
}
/deep/ .el-input {
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  input[type='number'] {
    -moz-appearance: textfield;
  }
}
</style>
